import { makeActionCreator } from 'utils/reduxUtils/reduxUtils';

export const types = {
  UPDATE_FRIENDS_LIST: '@jg/UPDATE_FRIENDS_LIST',
  UPDATE_AUTH_RESPONSE: '@jg/UPDATE_AUTH_RESPONSE',
  TOGGLE_FRIEND_SELECTION: '@jg/TOGGLE_FRIEND_SELECTION',
  REMOVE_FRIEND_SELECTION: '@jg/REMOVE_FRIEND_SELECTION',
  FILTER_FRIENDS: '@jg/FILTER_FRIENDS',
};

const actions = {
  fbLogin: () => (dispatch) => {
    const fbOptions = {
      scope: 'user_friends publish_actions',
      auth_type: 'rerequest',
      return_scopes: true,
    };

    /* istanbul ignore next */
    window.FB.login((response) => {
      if (response.authResponse && response.authResponse.grantedScopes && response.authResponse.grantedScopes.includes('publish_actions')) {
        dispatch({
          type: types.UPDATE_AUTH_RESPONSE,
          fbAuthResponse: response.authResponse,
        });
        dispatch(actions.getTaggableFriends());
      // } else {
      //   console.log('Authorization failed.');
      }
    }, fbOptions);
  },

  getTaggableFriends: () => (dispatch) => {
    /* istanbul ignore next */
    window.FB.api(
      '/me/taggable_friends?limit=5000',
      (response) => {
        if (response && !response.error) {
          dispatch({
            type: types.UPDATE_FRIENDS_LIST,
            fbFriendsData: response.data,
          });
        }
      },
    );
  },

  toggleFriendSelection: makeActionCreator(types.TOGGLE_FRIEND_SELECTION, 'id'),

  removeFriendSelection: makeActionCreator(types.REMOVE_FRIEND_SELECTION, 'id'),

  filterFriends: makeActionCreator(types.FILTER_FRIENDS, 'friendsFilterText'),

  postToFB: (fundraisingPageUrl, message, apiCallback) => (dispatch, getState) => {
    const state = getState();
    const { facebookInviteFriendsStore } = state;
    const friendList = facebookInviteFriendsStore.get('selectedFriends').toJS();

    const apiOptions = {
      link: fundraisingPageUrl,
      tags: friendList.join(','),
      message,
    };

    window.FB.api('/me/feed', 'POST', apiOptions, apiCallback);
  },
};

export default actions;



// WEBPACK FOOTER //
// ./actions/facebookInviteFriendsActions/facebookInviteFriendsActions.js